import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Song } from '../../../models/song'
import { LessonSong } from '../../../models/lesson-song'
import { Router } from '@angular/router'
import { Course } from '../../../models/course'
import { MenuController, PopoverController } from '@ionic/angular'
import { BowlingSongCssService } from '../bowling-song-css.service'
import { PreferencesProvider } from '../../../providers/preferences/preferences.provider'
import { BowlingActivityManagePopoverComponent } from '../bowling-activity-manage-popover/bowling-activity-manage-popover.component';
import { Common } from 'src/app/lib/common';
import { Lesson } from 'src/app/models/lesson';

@Component({
  selector: '[app-bowling-song]',
  templateUrl: './bowling-song.component.html',
  styleUrls: ['./bowling-song.component.scss']
})
export class BowlingSongComponent implements OnInit {

  @Input() course: Course
  @Input() song: Song
  @Input() lessonByPage: Lesson[];

  constructor(
    public bowlingSongCssService: BowlingSongCssService,
    private preferencesProvider: PreferencesProvider,
    private popoverCtrl: PopoverController,
  ) { }

  ngOnInit() {
  }

  isSongExpanded() {
    return this.preferencesProvider.isBowlingSongExpanded(this.song)
  }

  toggleSongExpanded() {
    this.preferencesProvider.setBowlingSongExpanded(this.song, !this.preferencesProvider.isBowlingSongExpanded(this.song))
  }

  activitiesInLesson(lessonIndex: number): any[] {
    const activityIndices = []

    if (lessonIndex < this.lessonByPage?.length) {
      const lesson = this.lessonByPage[lessonIndex]
      lesson.songs.forEach((lessonSong: LessonSong, index: number) => {
        if (lessonSong.songUuid === this.song.uuid || lessonSong.name == this.song.name) {
          activityIndices.push(index + 1) // convert from 0-based to 1 based
        }
      })
    }

    return activityIndices
  }

  openActivityManagePopover(lessonIndex){
    const lesson = this.lessonByPage[lessonIndex]
    const course = this.course
    const song = this.song

    this.popoverCtrl.create({
      component: BowlingActivityManagePopoverComponent,
      cssClass: 'access-code-popover',
      componentProps: {lesson, course, song}
    }).then(popover => {
      popover.present().then(() => Common.ensurePopoverOnScreen());
      popover.onDidDismiss().then(results => {
      if(results && results.data){

      }
    })
  })
  }

  isCourseAvailable(index: number) { 
    // only show popupmodal to lesson that are available.
    if (!(this.lessonByPage && this.lessonByPage?.length)) {
      return false;
    }
    return this.lessonByPage.length > index;
  }
}
